module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingCategories
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Faixa Etária",
      "columns": 3,
      "error": _vm.getError('ageGroup', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ageGroup),
      expression: "product.ageGroup"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.product.status === 'sent' || _vm.product.status === 'error'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "ageGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adult"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('skyhub.ageGroup.adult.label')) + "\n      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kids"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('skyhub.ageGroup.kids.label')) + "\n      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('skyhub.ageGroup.both.label')) + "\n      ")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categorias",
      "columns": 3,
      "error": _vm.getError('category', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categories,
      "label": "name",
      "track-by": "value",
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1), _vm._v(" "), (_vm.attributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "columns": 3,
        "error": _vm.getError(attribute.name, _vm.product.productId),
        "required": attribute.required
      }
    }, [(attribute.enum && attribute.enum.length) ? [_c('multiselect', {
      attrs: {
        "options": attribute.enum,
        "label": "name",
        "track-by": "value",
        "placeholder": attribute.name
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    })] : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37e0b26c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/skyhub/provide/Product.vue
// module id = 3055
// module chunks = 0